
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/preview/newsroom/[slug]",
      function () {
        return require("private-next-pages/preview/newsroom/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/preview/newsroom/[slug]"])
      });
    }
  